import React from "react";
import { Calendar } from "lucide-react";
import SectionHeading from "../SectionHeading/SectionHeading";

const FORM_URL = "https://info.mycertainpath.com/l/1112653/2026-04-13/72y2tg";

interface RequestWalkthroughFormProps {
  /** Anchor every CTA on the page scrolls to. */
  sectionId: string;
}

const RequestWalkthroughForm: React.FC<RequestWalkthroughFormProps> = ({
  sectionId,
}) => (
  <section className="relative bg-cream py-24 dark:bg-slate-900" id={sectionId}>
    <div className="mx-auto max-w-7xl px-6">
      <div className="mx-auto mb-10 max-w-2xl text-center">
        <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary/20 bg-cream-dark px-4 py-1.5 text-[0.7rem] font-semibold uppercase tracking-[0.14em] text-primary dark:bg-primary/15 dark:text-primary-light">
          <Calendar className="h-3.5 w-3.5" />
          Book Your Walkthrough
        </div>
        <SectionHeading>Request a Personalized Walkthrough</SectionHeading>
        <p className="mt-4 text-base leading-relaxed text-gray-500 dark:text-gray-400">
          Tell us about your team and we&rsquo;ll schedule a live demo of
          FieldCoach — and show you how the CertainPath Operating System comes
          to life on every call.
        </p>
      </div>

      <div className="mx-auto max-w-4xl">
        <div className="relative rounded-[1.25rem] border border-gray-200 bg-white px-4 pb-5 pt-8 shadow-xl dark:border-slate-700 dark:bg-slate-800 md:px-8">
          <span
            aria-hidden="true"
            className="absolute left-6 right-6 top-0 h-[3px] rounded-b bg-gradient-to-r from-primary to-secondary"
          />

          <iframe
            className="block w-full border-0 bg-transparent"
            height={500}
            src={FORM_URL}
            title="Request a FieldCoach walkthrough"
            width="100%"
          />

          <div className="mt-4 border-t border-gray-200 pt-4 text-center text-sm text-gray-500 dark:border-slate-700 dark:text-gray-400">
            Form not loading?{" "}
            <a
              className="font-bold text-primary no-underline hover:underline dark:text-primary-light"
              href={FORM_URL}
              rel="noopener noreferrer"
              target="_blank"
            >
              Open it in a new tab &rarr;
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default RequestWalkthroughForm;
